/* ITT OVERNIGHT 001 — progressive-enhancement compactions (ANIMATE-AND-COMPACT-001).
   Every enhancement is additive: with JS off, the original static clusters remain
   fully visible and usable (the flat twin). No auto-motion anywhere; all movement
   is visitor-stepped. Targets are >=48px (see itt-overnight-001.css). */
(function () {
  'use strict';
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* Accordion for a section whose groups are: <h3> label followed by content
     siblings until the next <h3>. First group open, the rest collapsed.
     The h3 stays in place (headings/twin untouched); a toggle button is
     inserted after each h3 and controls the group panel. */
  function groupAccordion(section, isContent) {
    if (!section || section.dataset.ittAcc) return;
    var headers = Array.prototype.filter.call(section.children, function (c) {
      return c.tagName === 'H3';
    });
    if (headers.length < 2) return;
    section.dataset.ittAcc = '1';
    headers.forEach(function (h, gi) {
      var panel = el('div', 'itt-acc-panel');
      panel.id = (section.id || 'acc') + '-panel-' + gi;
      var sib = h.nextSibling;
      var moved = [];
      while (sib && sib.tagName !== 'H3') {
        if (isContent(sib)) moved.push(sib);
        sib = sib.nextSibling;
      }
      if (!moved.length) return;
      h.parentNode.insertBefore(panel, moved[0]);
      moved.forEach(function (n) { panel.appendChild(n); });
      var btn = el('button', 'itt-acc-toggle');
      btn.type = 'button';
      btn.setAttribute('aria-controls', panel.id);
      var open = gi === 0;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.innerHTML = '<span class="itt-acc-label"></span><span class="itt-acc-cue" aria-hidden="true"></span>';
      btn.querySelector('.itt-acc-label').textContent =
        (open ? 'Hide' : 'Show') + ' — ' + (h.textContent || '').trim();
      btn.querySelector('.itt-acc-cue').textContent = open ? '−' : '+';
      if (!open) panel.hidden = true;
      btn.addEventListener('click', function () {
        var nowOpen = panel.hidden;
        panel.hidden = !nowOpen;
        btn.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
        btn.querySelector('.itt-acc-label').textContent =
          (nowOpen ? 'Hide' : 'Show') + ' — ' + (h.textContent || '').trim();
        btn.querySelector('.itt-acc-cue').textContent = nowOpen ? '−' : '+';
      });
      h.parentNode.insertBefore(btn, panel);
    });
  }

  /* Stepped stage for a grid of cards: one card on stage, prev/next + counter.
     No auto-advance. Without JS every card stays visible (the twin). */
  function steppedStage(grid, cardSel) {
    if (!grid || grid.dataset.ittStage) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll(cardSel));
    if (cards.length < 2) return;
    grid.dataset.ittStage = '1';
    grid.classList.add('itt-stage');
    var idx = 0;
    var nav = el('div', 'itt-stage-nav');
    var prev = el('button', 'itt-stage-btn', '← Prev');
    var next = el('button', 'itt-stage-btn', 'Next →');
    var count = el('span', 'itt-stage-count');
    count.setAttribute('role', 'status');
    [prev, next].forEach(function (b) { b.type = 'button'; });
    nav.appendChild(prev); nav.appendChild(count); nav.appendChild(next);
    grid.parentNode.insertBefore(nav, grid);
    function show(i) {
      idx = (i + cards.length) % cards.length;
      cards.forEach(function (c, ci) {
        c.classList.toggle('itt-stage-on', ci === idx);
        if (ci === idx) c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
      });
      count.textContent = 'Equation ' + (idx + 1) + ' of ' + cards.length;
    }
    prev.addEventListener('click', function () { show(idx - 1); });
    next.addEventListener('click', function () { show(idx + 1); });
    nav.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(idx - 1); }
      if (e.key === 'ArrowRight') { show(idx + 1); }
    });
    show(0);
  }

  /* Trust-card accordion ("Four answers"): each card's <b> becomes the toggle,
     first answer open. Without JS the 4-card row remains (the twin). */
  function trustAccordion(grid) {
    if (!grid || grid.dataset.ittAcc) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.wl-trustcard'));
    if (cards.length < 2) return;
    grid.dataset.ittAcc = '1';
    grid.classList.add('itt-trust-acc');
    cards.forEach(function (card, i) {
      var head = card.querySelector('b');
      var body = card.querySelector('p');
      if (!head || !body) return;
      var btn = el('button', 'itt-trust-toggle');
      btn.type = 'button';
      var open = i === 0;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.innerHTML = '<span class="itt-trust-label"></span><span class="itt-acc-cue" aria-hidden="true">' + (open ? '−' : '+') + '</span>';
      btn.querySelector('.itt-trust-label').textContent = head.textContent;
      head.replaceWith(btn);
      if (!open) body.hidden = true;
      btn.addEventListener('click', function () {
        var nowOpen = body.hidden;
        body.hidden = !nowOpen;
        btn.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
        btn.querySelector('.itt-acc-cue').textContent = nowOpen ? '−' : '+';
      });
    });
  }

  ready(function () {
    groupAccordion(document.getElementById('houseIndex'), function (n) {
      return n.nodeType === 1 && n.classList && n.classList.contains('uc-grid');
    });
    groupAccordion(document.getElementById('capabilityDirectory'), function (n) {
      return n.nodeType === 1 && n.classList && n.classList.contains('uc-cap');
    });
    var engine = document.querySelector('#enginePanel .mxGrid');
    if (engine) steppedStage(engine, '.mxCard');
    var trust = document.querySelector('.wl-trustgrid');
    if (trust) trustAccordion(trust);
  });
})();
